/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify'; 
import { fetchApi } from '../../utils/methods';
import { ImageUrl } from "../../utils/constants";
import { RecognitionCloseIcon, closeIcon, UploadIcon } from "../../utils/icons";
import { Layout, RadioGroup, RadioLabel } from '../EditWellnessJourney/styles';
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
} from '../CreateEvent/style';
import { FormHeading } from '../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { Main } from "../AdminTeamCreation/styles";
import { ManagerIconContainer } from "../Manager/styles";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { Border } from "../Journeys/styles";
import RadioButtonNew from '../ContentV2/CustomRadioButtonNew';
import CommonImageUploader from '../common/CommonImageUploader/CommonImageUploader';
import { AddWellnessCategory } from '../../redux/constants/apiConstants';


class CreateWellnessCategoryForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      category_type: props.categoryKey || 'ARTICLE', 
      category_name: '',
      image: '',
      imageName: '',
      loading: false,
      buttonstatus: false,
      uploaderKey: 0 // Added key to force re-render/reset of uploader on error
    }
  }

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeType = (type) => {
    this.setState({ category_type: type });
  }

  // Helper to force reset the uploader UI if validation fails
  resetUploader = () => {
    this.setState((prevState) => ({
      uploaderKey: prevState.uploaderKey + 1,
      image: '',
      imageName: ''
    }));
  }

  // Strict Image Validation Logic
  handleImageChange = (base64, fileName) => {
    const { t } = this.props;

    if (!base64 || !fileName) return;

    // 1. Format Validation (SVG or PNG)
    const validExtensions = ['png', 'svg'];
    const extension = fileName.split('.').pop().toLowerCase();
    
    if (!validExtensions.includes(extension)) {
      toast.error(t("Only PNG and SVG formats are allowed"));
      this.resetUploader(); // Reset UI
      return;
    }

    // 2. Size Validation (Max 200KB)
    // Formula: (Base64 string length - header) * 0.75 = Size in Bytes
    const stringLength = base64.length - (base64.indexOf(',') + 1);
    const sizeInBytes = stringLength * 0.75;
    const sizeInKB = sizeInBytes / 1024;

    if (sizeInKB > 200) {
      toast.error(t("File size must be less than or equal to 200KB"));
      this.resetUploader(); // Reset UI immediately
      return;
    }

    // 3. Dimension Validation (Strictly 100x100)
    const img = new window.Image(); 
    img.src = base64;
    
    img.onload = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      if (width !== 100 || height !== 100) {
        toast.error(t("Image dimensions must be exactly 100px x 100px"));
        this.resetUploader(); // Reset UI immediately
        return;
      }

      // If all Validations pass, set the state
      this.setState({
        image: base64,
        imageName: fileName
      });
    };

    img.onerror = () => {
      toast.error(t("Invalid image file"));
      this.resetUploader();
    };
  };

  handleRemoveImage = () => {
    this.setState({
      image: '',
      imageName: '',
    });
  };

  checkBase64 = (str) => {
    if (str === '' || str === null || str === undefined) return false;
    return str.includes('base64');
  }

  CreateCategory = async (payload) => {
    const fromAdmin = this.props.location?.state?.from  === "adminSide";
    this.setState({ buttonstatus: true, loading: true });
    try {
      const res = await fetchApi(AddWellnessCategory, "POST", payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Category created successfully");
        if (fromAdmin) {
          this.props.history.push("/company/wellness",{ activeTab: "Library",});
        } else {
          this.props.history.push("/wellness-resources");
        }
        // this.props.history.push("/wellness-resources"); 
        this.setState({ buttonstatus: false, loading: false });
      } else {
        const errorMsg = res?.data?.message || res?.message || "Something went wrong";
        toast.error(errorMsg);
        this.setState({ buttonstatus: false, loading: false });
      }
    } catch (error) {
      toast.error(error);
      this.setState({ buttonstatus: false, loading: false });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { image, category_name, category_type } = this.state;
    
    let data = {
      category_type: category_type,
      category_title: category_name, 
      category_image: image          
    };

    this.CreateCategory(data);
  };

  // redirect = () => {
  //   this.props.history.goBack();
  // };


  redirect = () => {

    const fromAdmin = this.props.location?.state?.from  === "adminSide";
  
    if (fromAdmin) {
      this.props.history.push("/company/wellness",{ activeTab: "Library",activeLibraryTab: "Articles"});
    } else {
      this.props.history.goBack();
    }
  };

  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Category")}
    </FormHeading>
  );

  isValid = () => {
    const { category_name, image } = this.state;
    return category_name.trim() !== '' && image !== '';
  }

  render() {
    const { image, category_name, category_type, loading, buttonstatus, uploaderKey } = this.state;
    const { t } = this.props;
    const isValid = this.isValid();
    const isLoading = loading || buttonstatus;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          
          <Container height="100%" stepBackground="#FFFFFF" color="#184A61">
            <div className="form" style={{width:'100%', marginLeft:"0" ,padding:'20px 20px 70px'}}> 
              <div className="formBody">
                
                <RadioGroup>
                  <RadioLabel onClick={() => this.onChangeType('ARTICLE')}>
                    <RadioButtonNew
                      isChecked={category_type === 'ARTICLE'}
                      handler={() => this.onChangeType('ARTICLE')}
                      value={'ARTICLE'}
                      background={"#85c0ea"}
                    />
                    {t("Articles")}
                  </RadioLabel>

                  <RadioLabel onClick={() => this.onChangeType('FITNESS')}>
                    <RadioButtonNew
                      isChecked={category_type === 'FITNESS'}
                      handler={() => this.onChangeType('FITNESS')}
                      value={'FITNESS'}
                      background={"#85c0ea"}
                    />
                    {t("Fitness")}
                  </RadioLabel>

                  <RadioLabel onClick={() => this.onChangeType('RECIPE')}>
                    <RadioButtonNew
                      isChecked={category_type === 'RECIPE'}
                      handler={() => this.onChangeType('RECIPE')}
                      value={'RECIPE'}
                      background={"#85c0ea"}
                    />
                    {t("Recipes")}
                  </RadioLabel>
                </RadioGroup>

                <Border style={{ background: '#EFEFEF', margin: '8px 0' }} />

                <InputContainer>
                  <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                    {t("Category Title")}<span>*</span>
                  </StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter category title")}
                    name="category_name"
                    onChange={this.onChangeInput}
                    value={category_name}
                    maxLength="100"
                    bgColor={"white"}
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{category_name.length}/100 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <StyledLabel isFont={"16px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                  {t("Category Icon")}<span>*</span>
                </StyledLabel>

                
                <div className='imgUploder' style={{ width: '182px', height: '182px' }}>
                  <CommonImageUploader
                    key={uploaderKey} 
                    imgSrc={this.checkBase64(image) ? image : image ? `${ImageUrl}/${image}` : ""}
                    t={t}
                    closeIcon={closeIcon}
                    UploadIcon={UploadIcon}
                    label={t("Upload Icon")} 
                    onImageChange={this.handleImageChange}
                    onRemoveImage={this.handleRemoveImage}
                    accept=".svg, .png" 
                  />
                  <div style={{ color: '#989898', fontSize: '12px', marginTop: '8px' }}>
                    {t("Size 100px*100px")}
                  </div>
                </div>
              </div>
            </div>
          </Container>

          <ButtonContainer style={{left:'80px'}}>
            <Main>
              <div className="wrapper" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                <CommonButtonPopup
                  height="48px"
                  width="200px"
                  margin="auto 0 auto auto"
                  disabled={!isValid || isLoading}
                  onClick={isValid ? this.onSubmit : null}
                  style={{
                    backgroundColor: (isValid && !isLoading) ? '#DA6C74' : '#EFEFEF',
                    cursor: (isValid && !isLoading) ? 'pointer' : 'not-allowed',
                    color: (isValid && !isLoading) ? '#FFFFFF' : '#989898'
                  }}
                >
                  {isLoading ? t("Creating...") : t("Create")}
                </CommonButtonPopup>
              </div>
            </Main>
          </ButtonContainer>

        </div>
      </Layout>
    )
  }
}

CreateWellnessCategoryForm.propTypes = {
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  isAdminRoute: PropTypes.bool,
  categoryKey: PropTypes.string,
  location: PropTypes.object
};

const mapStateToProps = (state) => ({
  isLoading: state.education.isLoading
});

export default withRouter(connect(mapStateToProps,null)(withTranslation()(CreateWellnessCategoryForm)));